/**
 * Função para verificar se um valor é "preço sob consulta"
 * @param {string} value - O valor a ser verificado
 * @returns {boolean} - true se for preço sob consulta, false caso contrário
 */
export const isConsultationPrice = (value) => {
	return value && (
		value.includes("consultation") || 
		value.includes("consulta") || 
		value.includes("sob consulta") ||
		value.includes("Contact us") ||
		value.includes("Contactar") ||
		value.includes("Price upon request") ||
		value.includes("price upon request") ||
		value.includes("upon request") ||
		value.includes("Preço no local") ||
		value.includes("Preço no local") ||
		value.includes("Precio bajo consulta") ||
		value.includes("precio bajo consulta") ||
		value.includes("bajo consulta") ||
		value.includes("Request price") ||
		value.includes("request price") ||
		value.includes("Solicitar precio") ||
		value.includes("solicitar precio")
	);
};

/**
 * Verifica se todos os preços fornecidos são "preço sob consulta"
 * @param {Array} prices - Array de preços a serem verificados
 * @returns {boolean} - true se todos forem preço sob consulta, false caso contrário
 */
export const areAllConsultationPrices = (prices) => {
	return prices.every(price => isConsultationPrice(price));
};
